module.exports = __webpack_public_path__ + "static/img/6.bd4b037.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/eng/6.png
// module id = t3La
// module chunks = 0